import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sliceText',
})
export class SliceTextPipe implements PipeTransform {
  transform(value: string, numberSliced: number, showFullText: boolean): { showButton: boolean; value: string } {
    if (!value || typeof value !== 'string' || numberSliced <= 0) {
      return { showButton: false, value: '' };
    }

    const words = value.split(' ');
    if (words.length <= numberSliced) return { showButton: false, value };

    if (showFullText) {
      return { showButton: true, value };
    } else {
      return {
        showButton: true,
        value: words.slice(0, numberSliced).join(' ') + '...',
      };
    }
  }
}
